import { render, staticRenderFns } from "./CommentFlagModal.vue?vue&type=template&id=018f7018&"
import script from "./CommentFlagModal.vue?vue&type=script&lang=js&"
export * from "./CommentFlagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports